(function (window, $) {
	let self;
	const Dismequi = {

		initialize() {
			self = this;
			self.resolutions = {
				xs: { min: 0, max: 767 },
				sm: { min: 768, max: 991 },
				md: { min: 992, max: 1199 },
				lg: { min: 1200, max: 1600 }
			};

			self.resolution = 'lg';
			$(document).ready(self.documentReady);
		},

		documentReady() {},

		GetProduct(url) {
			return new Promise((resolve, reject) => {
				const dataType = 'json';
				const success = response => resolve(response);
				const error = reason => reject(reason);
				$.ajax({ url, dataType, success, error });
			});
		},

		GetHost() {
			const host = location.host;
			const protocol = location.protocol;
			const webName = () => {
				const arr = location.href.split('/').filter(x => x);
				return arr[2];
			};
			const base = host === 'localhost' ? `localhost/${webName()}` : host;
			return `${protocol}://${base}/`;
		},

		GetFilter() {
			const filter = $('#filter').text();
			return JSON.parse(filter);
		},

		GetFilterChilds(id) {
			const filter = this.GetFilter();
			for( const index in filter) {
				if (filter[index].id == id) {
					return filter[index].child;
				}
			}
		},

		Search(word, category, subcategory) {
			let url = `${this.GetHost()}?s=${word}`;
			url += category ? `&category=${category}` : '';
			url += subcategory ? `&subcategory=${subcategory}` : '';

			return new Promise((resolve, reject) => {
				const success = response => resolve(response);
				const error = reason => reject(reason);
				const dataType = 'html';
				$.ajax({ url, dataType, success, error });
			});
		},

		Check : {
			isHome() {
				return $('body').hasClass('home');
			},

			isProduct() {
				return $('body').hasClass('category-producto');
			}
		},

		validation: {
			name: /^[A-Z]+\n^[A-Z]+\n^[A-Z]/i,
			alpha: /[a-z]/ig,
			numeric: /[0-9]/ig,
			alphaNumeric: /\w/i,
			alphaNumericPunctuation: /\W/i,
			email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
			date: /^([0][1-9]|[12][0-9]|3[01])(\/)([0][1-9]|[1][0-2])\2(\d{4})$/,
			url: /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
		}

	};

	window.Code = Dismequi;

})(window, jQuery);

(function (window, $, Code) {
	
	const tmpl = {

		selectorOptions(json) {
			let html = '';
			for (const index in json) {
				const ref = json[index];
				html += `<li class="select__option" data-id="${ref.id}" data-value="${ref.slug}">${ref.name}</li>`;
			}
			return html;
		},

		selectorFilter(json, cat) {
			const optionsHTML = tmpl.selectorOptions(json);
			return `<div class="search__select select" data-type="category">
						<div class="select__view">Elige una categoria</div>
						<div class="ico ico__arrow-collapse"></div>
						<ul class="select__combo"> ${optionsHTML} </ul>
					</div>
					<div class="search__select select" data-type="subcategory">
						<div class="select__view">Elige una subcategoria</div>
						<div class="ico ico__arrow-collapse"></div>
						<ul class="select__combo"></ul>
					</div>`;
		}

	};

	const fnProduct = {

		viewProduct(event) {
			event.preventDefault();
			const target = event.currentTarget.parentNode;
			const data = target.dataset.info;

			const modal = $('#bs-modal-product');
			const description = modal.find('.modal-product__description');
			const subtitle = modal.find('.modal-product__subtitle');
			const image = modal.find('.modal-product__image picture');
			const title = modal.find('.modal-product__title');
			const link = modal.find('.modal-product__link');

			Code.GetProduct(data)
				.then((product) => {
					const Old = link.attr('href');
					const New = Old.replace('{product}', product.title);

					link.attr('href', New);
					title.text(product.title);
					subtitle.html(product.taxonomies);
					description.text(product.content);

					image
						.find('img')
						.attr('src', product.image.desktop);

					modal.modal('show');
				})
				.catch(reason => console.error(reason));
		},
		
		viewCertificate(event) {
			event.preventDefault();
			const target = event.currentTarget.parentNode.parentNode;
			const data = target.dataset.info;

			const modal = $('#bs-modal-product');
			const description = modal.find('.modal-product__description');
			const subtitle = modal.find('.modal-product__subtitle');
			const image = modal.find('.modal-product__image picture');
			const title = modal.find('.modal-product__title');
			const link = modal.find('.modal-product__link');

			Code.GetProduct(data)
				.then((certificate) => {
					link.attr('href', certificate.download);
					title.text(certificate.title);
					description.text(certificate.content);

					image
						.find('img')
						.attr('src', certificate.image.desktop);

					modal.modal('show');
				})
				.catch(reason => console.error(reason));
		},

		createFilter() {
			const container = $('.search__wrapper');
			const categories = Code.GetFilter();
			const html = tmpl.selectorFilter(categories, true);

			container.find('.search__select.select').remove();
			container.prepend(html);
		}

	};

	const events = {

		selectRoll(event, option = false) {
			const node = event.target.parentNode;
			const parent = option ? node.parentNode : node;
			const $parent = $(parent);
			const $combo = $parent.find('.select__combo');
			const $ico = $parent.find('.ico');
			const replace = (Old, New) => $ico.removeClass(Old).addClass(New);

			if ($ico.hasClass('ico__arrow-collapse'))
				replace('ico__arrow-collapse', 'ico__arrow-no-collapse');
			else
				replace('ico__arrow-no-collapse', 'ico__arrow-collapse');

			$combo.toggle();
		},

		selectSub(event) {
			const node = event.target;
			const $parent = $(node.parentNode.parentNode);
			const $isSub = $parent.data('type') === 'subcategory';
			const $subcategory = $('.select[data-type="subcategory"]');
			const $subcombo = $subcategory.find('.select__combo');

			const name = $(node).text();
			const id = node.dataset.id;
			const options = Code.GetFilterChilds(id);

			$parent
				.find('.select__option')
				.removeClass('active');

			$(node)
				.addClass('active');

			$parent
				.find('.select__view')
				.html(name);

			if (!$isSub)
				$subcombo.html(tmpl.selectorOptions(options));

			events.selectRoll(event, true);
		},

		search() {
			const productContent = $('.product .product__wrapper');
			const words = $('.search input.submit__input').val();
			let subcategory = $('.search .search__select[data-type="subcategory"] .select__option.active');
			subcategory = subcategory ? subcategory.data('value') : null;
			let category = $('.search .search__select[data-type="category"] .select__option.active');
			category = category ? category.data('value') : null;

			Code
				.Search(words, category, subcategory)
				.then((response) => productContent.html(response))
				.catch(reason => console.error(reason));
		}

	}

	const bindEvent = () => {
		$('body')
			.on('click', '.js-product-description', fnProduct.viewProduct)
			.on('click', '.js-certificate-description', fnProduct.viewCertificate)
			.on('click', '.select .select__option', events.selectSub)
			.on('click', '.search .submit__button', events.search)
			.on('click', '.select', events.selectRoll);

	};

	if (Code.Check.isProduct())
		fnProduct.createFilter();

	Code.Product = fnProduct;
	bindEvent();

})(window, jQuery, Code);